const stub_tcfv2 = () => {
  !function(t) {
    var e = {};
    function n(r) {
      if (e[r]) return e[r].exports;
      var o = e[r] = { i: r, l: false, exports: {} };
      return t[r].call(o.exports, o, o.exports, n), o.l = true, o.exports;
    }
    n.m = t, n.c = e, n.d = function(t2, e2, r) {
      n.o(t2, e2) || Object.defineProperty(t2, e2, { enumerable: true, get: r });
    }, n.r = function(t2) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t2, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t2, "__esModule", { value: true });
    }, n.t = function(t2, e2) {
      if (1 & e2 && (t2 = n(t2)), 8 & e2) return t2;
      if (4 & e2 && "object" == typeof t2 && t2 && t2.__esModule) return t2;
      var r = /* @__PURE__ */ Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: true,
        value: t2
      }), 2 & e2 && "string" != typeof t2)
        for (var o in t2)
          n.d(
            r,
            o,
            function(e3) {
              return t2[e3];
            }.bind(null, o)
          );
      return r;
    }, n.n = function(t2) {
      var e2 = t2 && t2.__esModule ? function() {
        return t2.default;
      } : function() {
        return t2;
      };
      return n.d(e2, "a", e2), e2;
    }, n.o = function(t2, e2) {
      return Object.prototype.hasOwnProperty.call(t2, e2);
    }, n.p = "", n(n.s = 3);
  }([
    function(t, e, n) {
      var r = n(2);
      t.exports = !r(function() {
        return 7 != Object.defineProperty({}, "a", {
          get: function() {
            return 7;
          }
        }).a;
      });
    },
    function(t, e) {
      t.exports = function(t2) {
        return "object" == typeof t2 ? null !== t2 : "function" == typeof t2;
      };
    },
    function(t, e) {
      t.exports = function(t2) {
        try {
          return !!t2();
        } catch (t3) {
          return true;
        }
      };
    },
    function(t, e, n) {
      n(4), function() {
        if ("function" != typeof window.__tcfapi) {
          var t2, e2 = [], n2 = window, r = n2.document;
          !n2.__tcfapi && function t3() {
            var e3 = !!n2.frames.__tcfapiLocator;
            if (!e3)
              if (r.body) {
                var o = r.createElement("iframe");
                o.style.cssText = "display:none", o.name = "__tcfapiLocator", r.body.appendChild(o);
              } else setTimeout(t3, 5);
            return !e3;
          }() && (n2.__tcfapi = function() {
            for (var n3 = arguments.length, r2 = new Array(n3), o = 0; o < n3; o++)
              r2[o] = arguments[o];
            if (!r2.length) return e2;
            if ("setGdprApplies" === r2[0])
              r2.length > 3 && 2 === parseInt(r2[1], 10) && "boolean" == typeof r2[3] && (t2 = r2[3], "function" == typeof r2[2] && r2[2]("set", true));
            else if ("ping" === r2[0]) {
              var i = {
                gdprApplies: t2,
                cmpLoaded: false,
                apiVersion: "2.0"
              };
              "function" == typeof r2[2] && r2[2](i, true);
            } else e2.push(r2);
          }, n2.addEventListener(
            "message",
            function(t3) {
              var e3 = "string" == typeof t3.data, r2 = {};
              try {
                r2 = e3 ? JSON.parse(t3.data) : t3.data;
              } catch (t4) {
              }
              var o = r2.__tcfapiCall;
              o && n2.__tcfapi(
                o.command,
                o.version,
                function(n3, r3) {
                  var i = {
                    __tcfapiReturn: {
                      returnValue: n3,
                      success: r3,
                      callId: o.callId
                    }
                  };
                  e3 && (i = JSON.stringify(i)), t3.source.postMessage(i, "*");
                },
                o.parameter
              );
            },
            false
          ));
        }
      }();
    },
    function(t, e, n) {
      var r = n(0), o = n(5).f, i = Function.prototype, c = i.toString, u = /^s*function ([^ (]*)/;
      r && !("name" in i) && o(i, "name", {
        configurable: true,
        get: function() {
          try {
            return c.call(this).match(u)[1];
          } catch (t2) {
            return "";
          }
        }
      });
    },
    function(t, e, n) {
      var r = n(0), o = n(6), i = n(10), c = n(11), u = Object.defineProperty;
      e.f = r ? u : function(t2, e2, n2) {
        if (i(t2), e2 = c(e2, true), i(n2), o)
          try {
            return u(t2, e2, n2);
          } catch (t3) {
          }
        if ("get" in n2 || "set" in n2)
          throw TypeError("Accessors not supported");
        return "value" in n2 && (t2[e2] = n2.value), t2;
      };
    },
    function(t, e, n) {
      var r = n(0), o = n(2), i = n(7);
      t.exports = !r && !o(function() {
        return 7 != Object.defineProperty(i("div"), "a", {
          get: function() {
            return 7;
          }
        }).a;
      });
    },
    function(t, e, n) {
      var r = n(8), o = n(1), i = r.document, c = o(i) && o(i.createElement);
      t.exports = function(t2) {
        return c ? i.createElement(t2) : {};
      };
    },
    function(t, e, n) {
      (function(e2) {
        var n2 = function(t2) {
          return t2 && t2.Math == Math && t2;
        };
        t.exports = n2("object" == typeof globalThis && globalThis) || n2("object" == typeof window && window) || n2("object" == typeof self && self) || n2("object" == typeof e2 && e2) || Function("return this")();
      }).call(this, n(9));
    },
    function(t, e) {
      var n;
      n = /* @__PURE__ */ function() {
        return this;
      }();
      try {
        n = n || new Function("return this")();
      } catch (t2) {
        "object" == typeof window && (n = window);
      }
      t.exports = n;
    },
    function(t, e, n) {
      var r = n(1);
      t.exports = function(t2) {
        if (!r(t2)) throw TypeError(String(t2) + " is not an object");
        return t2;
      };
    },
    function(t, e, n) {
      var r = n(1);
      t.exports = function(t2, e2) {
        if (!r(t2)) return t2;
        var n2, o;
        if (e2 && "function" == typeof (n2 = t2.toString) && !r(o = n2.call(t2)))
          return o;
        if ("function" == typeof (n2 = t2.valueOf) && !r(o = n2.call(t2)))
          return o;
        if (!e2 && "function" == typeof (n2 = t2.toString) && !r(o = n2.call(t2)))
          return o;
        throw TypeError("Can't convert object to primitive value");
      };
    }
  ]);
};

export { stub_tcfv2 };
